module.exports = __webpack_public_path__ + "static/img/failed1.99d33524.png";